import { API_PROFILE_WEB_PREFIX } from "config/api-consts";
import { BASE_API_URL } from "config/consts";
import { httpConfig } from "config/http";
import { kebabCase } from "lodash";
import { Model, Repository } from "react3l-common";
import { Observable } from "rxjs";
import nameof from "ts-nameof.macro";

export type KeyType = string | number;

export class ProfileWebRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.baseURL = new URL(API_PROFILE_WEB_PREFIX, BASE_API_URL).href;
  }

  public get = (): Observable<Model> => {
    return this.http
      .post(kebabCase(nameof(this.get)))
      .pipe(Repository.responseMapToModel<Model>(Model));
  };
}

export const profileWebRepository = new ProfileWebRepository();
